// Home Custom Section JavaScript Enhancements
document.addEventListener('DOMContentLoaded', function() {
  // Initialize scroll animation observation
  const observeBlocks = () => {
    const blocks = document.querySelectorAll('.dt-sc-custom-block');
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        }
      });
    }, {
      threshold: 0.2,
      rootMargin: '0px 0px -100px 0px'
    });
    
    blocks.forEach(block => {
      observer.observe(block);
    });
  };
  
  // Initialize hover effects
  const initHoverEffects = () => {
    const images = document.querySelectorAll('.dt-sc-block-image');
    
    images.forEach(img => {
      img.addEventListener('mouseenter', function() {
        this.style.transform = 'scale(1.05)';
      });
      
      img.addEventListener('mouseleave', function() {
        this.style.transform = 'scale(1)';
      });
    });
  };
  
  // Initialize responsive handling
  const initResponsiveHandling = () => {
    const updateColumnVariables = () => {
      const sections = document.querySelectorAll('.home-custom-section');
      
      sections.forEach(section => {
        // Get content width values from section data attributes
        const leftColumn = section.getAttribute('data-left-column') || '50';
        const rightColumn = section.getAttribute('data-right-column') || '50';
        const lapLeftColumn = section.getAttribute('data-lap-left-column') || '40';
        const lapRightColumn = section.getAttribute('data-lap-right-column') || '60';
        const columnGap = section.getAttribute('data-column-gap') || '30';
        
        // Set CSS variables
        section.style.setProperty('--leftColumn', leftColumn);
        section.style.setProperty('--rightColumn', rightColumn);
        section.style.setProperty('--lap_leftColumn', lapLeftColumn);
        section.style.setProperty('--lap_rightColumn', lapRightColumn);
        section.style.setProperty('--column-gap', columnGap);
      });
    };
    
    // Run on page load and resize
    updateColumnVariables();
    window.addEventListener('resize', updateColumnVariables);
  };
  
  // Run all initializations
  observeBlocks();
  initHoverEffects();
  initResponsiveHandling();
  
  // Check for theme editor events
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      if (event.target.classList.contains('home-custom-section')) {
        observeBlocks();
        initHoverEffects();
        initResponsiveHandling();
      }
    });
  }
});
